import React from 'react'
import PropTypes from 'prop-types'

const Comment = ({ text }) => {
  return <span className="hidden" dangerouslySetInnerHTML={{ __html: `<!--${text}-->` }} />
}

Comment.propTypes = {
  text: PropTypes.string,
}

export default Comment
